import type { DiagnosticReportModel } from '@ctw/shared/api/fhir/models/diagnostic-report';
import type { ResourceTableSortOption } from '@ctw/shared/content/resource/resource-table-actions';
import {
  type DiagnosticReportSortParams,
  Sort,
} from '@ctw/shared/types/graphql/__generated__/graphql';

export const diagnosticReportSortOptions: Array<ResourceTableSortOption<DiagnosticReportModel>> = [
  {
    display: 'Date (New to Old)',
    sorts: [{ key: 'date', dir: 'desc', isDate: true }],
  },
  {
    display: 'Date (Old to New)',
    sorts: [{ key: 'date', dir: 'asc', isDate: true }],
  },
  {
    display: 'Name (A-Z)',
    sorts: [{ key: 'displayName', dir: 'asc' }],
  },
  {
    display: 'Name (Z-A)',
    sorts: [{ key: 'displayName', dir: 'desc' }],
  },
];

export const defaultDiagnosticReportSort = diagnosticReportSortOptions[0];

// Default server ordering for the ctw-diagnostics-resource-view-controls-server-side path;
// mirrors defaultDiagnosticReportSort (Date, New to Old).
export const defaultDiagnosticReportFqsSortParams: DiagnosticReportSortParams = {
  date: Sort.Desc,
};

// Maps a sort-menu selection to the FQS DiagnosticReportSortParams the server-side diagnostics
// path pages against.
export function diagnosticReportSortToFqsSortParams(
  option: ResourceTableSortOption<DiagnosticReportModel>,
): DiagnosticReportSortParams {
  switch (option.sorts[0].key) {
    case 'date':
      return { date: option.sorts[0].dir === 'asc' ? Sort.Asc : Sort.Desc };
    case 'displayName':
      return { name: option.sorts[0].dir === 'asc' ? Sort.Asc : Sort.Desc };
    default:
      return defaultDiagnosticReportFqsSortParams;
  }
}
